PegasusTemplate.ApplicationView = Ember.View.extend({
  templateName: 'application',
  classNames: ['vr-application'],

  classNameBindings: [
    'status',
    'subStatus'
  ],

  status: function(){
    return PegasusTemplate.get('status');
  }.property('PegasusTemplate.status'),

  subStatus: function(){
    return PegasusTemplate.get('subStatus');
  }.property('PegasusTemplate.subStatus'),

  scrollPane: function(){
    return this.$('.center-panel');
  }.property().volatile(),

  scrollContent: function(){
    return this.$('.center-wrapper');
  }.property().volatile(),

  adjustedHeight: function(){
    return this.get('scrollPane').height() - this.$('.subject').height();
  }.property().volatile(),

  didInsertElement: function(){
    this._super();
    this.catchKeys();
    this.bindBodyClick();
  },

  bindBodyClick: function(){
    $(window).on('click', function(e){
      if ( e.target.tagName === 'BODY' ) {
        Em.run(PegasusTemplate.stateMachine, 'send', 'didFinishEditing');
      }
    });
  },

  filteredKeys: [8,46],

  shouldKeyFilter: function(code){
    if ( code === 27 ) {
      this.get('controller').send('escape');
    }
    return this.filteredKeys.contains(code) &&
      !$('input, textarea, [contenteditable]').is(':focus');
  },

  catchKeys: function(){
    $(window).keydown(function(e) {
      var keyFilter = this.shouldKeyFilter(e.keyCode);
      if(keyFilter) {
        e.stopPropagation();
        return;
      }

      var active, tabs;

      if ( e.keyCode === 9 ) {
        if ( $('input:focus').length ) { return; }
        if ( $('.cke_editable').length ) { return; }

        tabs = $('.toolbar-top > .tabs').first();
        active = tabs.find('.active');
        if ( active.next().length ) {
          active.next().click();
        } else {
          tabs.find('li').first().click();
        }
        return false;
      }

      if ( e.keyCode === 33 ) {
        $('.center-wrapper-container').scrollTo(0);
        return false;
      }
      if ( e.keyCode === 34 ) {
        $('.center-wrapper-container').scrollTo(
          $('.center-wrapper').height()
        );
        return false;
      }

    }.bind(this));
  }
});
